module.exports = __webpack_public_path__ + "img/knife_karambit.5dbc1319.svg";